import { render } from "./ModuliRrSales.vue?vue&type=template&id=5e6ed2b3"
import script from "./ModuliRrSales.vue?vue&type=script&lang=js"
export * from "./ModuliRrSales.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__